// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".not-found[data-v-06bf4fe2] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.wrapper[data-v-06bf4fe2] {\n  display: flex;\n  justify-content: center;\n}\n.button[data-v-06bf4fe2] {\n  display: flex;\n  justify-content: flex-end;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
